// eslint-disable-next-line no-unused-vars
import React, { CSSProperties, useCallback, useEffect, useRef } from "react";
import XScroll from "./XScroll";
import XViewportList from "./_gears/XViewportList";

/**
 * @typedef {Object} xvpscrollparamsAddOns
 * @property {JSX.Element} injectBefore
 * @property {*[]} items
 * @property {JSX.Element} injectAfter
 * @property {number} overscan - Number of extra items to render outside the viewport for smoother scrolling.
 * @property {(callbacks: {scrollToBottom: () => void, scrollToIndex: (index: number) => void}) => void} onMounted
 * 
 * @typedef {import("./XScroll").xscrollparams} xscrollparams
 * 
 * @typedef {xscrollparams & xvpscrollparamsAddOns} xvpScrollparams
 * 
 * @param {xvpScrollparams} param0
 */
function XVPScroll({
  children,
  items,
  injectAfter,
  injectBefore,
  onMounted,
  overscan,
  ...others
}){

  const ref = useRef(null);
  const vpref = useRef(null);
  
  const scrollToBottom = useCallback(() => {
    if(ref.current){
      ref.current.scrollTo({
        top: ref.current.scrollHeight
      });
    }
  }, [ref]);

  const scrollToIndex = useCallback((index) => {
    if(ref.current && vpref.current){
      vpref.current?.scrollToIndex(index);
    }
  }, [ref, vpref]);

  useEffect(() => {
    if(ref.current && onMounted){
      let callbacks = {
        scrollToBottom: () => scrollToBottom(),
        scrollToIndex: (index) => scrollToIndex({index})
      };
      onMounted(callbacks);
    }
  }, [onMounted, scrollToBottom, scrollToIndex]);

  return (
    <XScroll overflow="auto" forwardRef={ref} overflowScroll {...others}>
      {injectBefore}
      <XViewportList viewportRef={ref} items={items} overscan={overscan} ref={vpref}>
        {children}
      </XViewportList>
      {injectAfter}
    </XScroll>
  );
}

export default XVPScroll;